import React from 'react';
import { homeSteps, roomNeeds } from '../data/content';
import { Eyebrow, Highlight, SectionTitle } from './ui/Section';
export function RealHomes() {
  return <section className="border-y border-slate-200 bg-white px-4 py-12 md:py-16" data-id="element-330" data-mp="3owp5fq3sx80k">
      <div className="mx-auto grid max-w-5xl items-start gap-10 md:grid-cols-[1fr_1.1fr] md:gap-14" data-id="element-331" data-mp="3jvj9zkirb6nc">
        <div data-id="element-332" data-mp="3fvh6r6xdi55y">
          <Eyebrow data-id="element-333" data-mp="3fw0puqyrezlk">🏡 Built for Real Homes</Eyebrow>
          <SectionTitle data-id="element-334" data-mp="gdhm61ww9lbj">What happens when every room has a different type of clutter?</SectionTitle>
          <ul className="mt-6 space-y-2 text-center text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-335" data-mp="bghg3r01oikf">
            {roomNeeds.map(line => <li key={line} data-id="element-336" data-mp="2ne5dqgsajth">{line}</li>)}
          </ul>
          <p className="mt-6 text-center text-lg font-black text-blue-950 md:text-xl" data-id="element-337" data-mp="2mw2wc3j39d4">
            <Highlight data-id="element-338" data-mp="z6lla2svsqdj">CLEAR THE CLUTTER™ organizes the process for you.</Highlight>
          </p>
        </div>

        <div data-id="element-339" data-mp="uc7ihfbw3gyu">
          <ol className="relative space-y-4 border-l-2 border-amber-300 pl-6" data-id="element-340" data-mp="uch9954rds5l">
            {homeSteps.map(([number, title, text]) => <li key={number} className="relative" data-id="element-341" data-mp="ojnbd0ks4qo5">
                <span className="absolute -left-[39px] flex h-7 w-7 items-center justify-center rounded-full bg-blue-950 text-xs font-black text-amber-400" data-id="element-342" data-mp="ol84clrg41jw">
                  {number}
                </span>
                <p className="text-base font-black uppercase text-blue-950 md:text-lg" data-id="element-343" data-mp="er7uk6l7y84u">{title}</p>
                <p className="mt-0.5 text-sm font-semibold text-slate-600 md:text-base" data-id="element-344" data-mp="w5o9icgmgri">{text}</p>
              </li>)}
          </ol>
          <p className="mt-6 rounded-xl bg-slate-50 px-4 py-3 text-sm font-bold text-slate-700" data-id="element-345" data-mp="3n22n4d2jv1sq">
            Designed for everyday homes with different types of physical clutter.
          </p>
        </div>
      </div>
    </section>;
}